import { userDestinationsActions } from '@anm/store/modules/userDestinations';
import { CHECK_DESTINATIONS_KEY } from '@anm/constants/keys';
import browserStore from '@anm/helpers/browserStore';
import isDev from '@anm/helpers/is/isDev';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const ONE_MIN = 1000 * 60;
const FIVE_MIN = ONE_MIN * 5;
const ONE_HOUR = ONE_MIN * 60;

const checkInterval = isDev() ? FIVE_MIN : ONE_HOUR;

const useCheckDestinations = () => {
  const dispatch = useDispatch();
  const lastCheckTime = browserStore.get(CHECK_DESTINATIONS_KEY) as Date | null;

  useEffect(() => {
    if (!lastCheckTime) return;

    const timer = setTimeout(() => {
      dispatch(userDestinationsActions.checkDestinations());
      clearTimeout(timer);
    }, checkInterval);

    return () => {
      clearTimeout(timer);
    };
  }, [lastCheckTime]);
};

export default useCheckDestinations;
